import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../utils/translations';
import { TERMINAL_ENABLED } from '../config/features';

const FOOTER_LINKS = [
  { to: '/about', key: 'nav.about' },
  { to: '/institutional', key: 'nav.institutional' },
  { to: '/contact', key: 'nav.contact' },
  { to: '/reports', key: 'nav.reports' },
  ...(TERMINAL_ENABLED ? [{ to: '/terminal', key: 'nav.macroTerminal' }] : []),
  { to: '/research', key: 'nav.research' },
  { to: '/quant-lab', key: 'nav.quantLab' },
  { to: '/yggdrasil', key: 'nav.engine' },
  { to: '/privacy', key: 'footer.privacy' },
  { to: '/terms', key: 'footer.terms' },
  { to: '/legal', key: 'footer.legal' },
];

export default function Footer() {
  const { language } = useLanguage();

  return (
    <footer style={{
      padding: '48px 48px 32px',
      borderTop: '1px solid rgba(255,255,255,0.05)',
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '28px',
        flexWrap: 'wrap',
        gap: '24px',
      }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
            <div style={{
              width: '6px', height: '6px', background: '#00ffc8', borderRadius: '1px',
              boxShadow: '0 0 8px rgba(0,255,200,0.4)',
            }} />
            <span style={{
              fontFamily: "'Bebas Neue', sans-serif",
              fontSize: '16px',
              letterSpacing: '3px',
              color: '#555',
            }}>HMA QUANT</span>
          </div>
          <p style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: '12px',
            color: '#555',
            maxWidth: '360px',
            lineHeight: 1.6,
          }}>
            {t('footer.tagline', language)}
          </p>
        </div>
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '8px 18px',
          maxWidth: '560px',
          justifyContent: 'flex-end',
        }}>
          {FOOTER_LINKS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '12px',
                color: '#666',
                textDecoration: 'none',
              }}
            >
              {t(item.key, language)}
            </Link>
          ))}
        </div>
      </div>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: '12px',
        flexWrap: 'wrap',
        paddingTop: '16px',
        borderTop: '1px solid rgba(255,255,255,0.03)',
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: '11px',
        color: '#444',
      }}>
        <span>© 2026 — {t('footer.rights', language)}</span>
        <span>{t('footer.disclaimer', language)}</span>
      </div>

      <p style={{
        marginTop: '10px',
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: '10px',
        color: '#3d3d3d',
        lineHeight: 1.5,
      }}>
        {t('footer.intradayNote', language)}
      </p>
    </footer>
  );
}
